import React from 'react';
import AppIcon from '@/components/haccp/AppIcon';

export default function PageHeader({ eyebrow, title, description, action, icon, showIcon = false }) {
  return (
    <div className="klaro-page-header">
      <div className="min-w-0">
        {eyebrow && <p className="klaro-page-header__eyebrow">{eyebrow}</p>}
        <div className="flex min-w-0 items-center gap-3">
          {showIcon && icon && (
            <div className="klaro-page-header__icon" aria-hidden="true">
              <AppIcon icon={icon} size="page" className="max-h-10 max-w-11" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="klaro-page-header__title">{title}</h1>
            {description && <p className="klaro-page-header__description">{description}</p>}
          </div>
        </div>
      </div>
      {action && <div className="klaro-page-header__action">{action}</div>}
    </div>
  );
}
